import {Dialog, DialogContent} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import AncillaryExceptionContent from "./AncillaryExceptionContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const AncillaryExceptionContainerView = ({
                                             ancillaryExceptionId,
                                             open,
                                             setOpen
                                         }: { ancillaryExceptionId: number, open: boolean, setOpen: Function }) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Dialog
            open={open}
            maxWidth={"xl"}
            fullWidth
            onClose={() => {
                setOpen(false);
            }}
        >
            <DialogTitle sx={{m: 0, p: 2}}>
                {t("pricing:ancillaryExceptions.sections.ancillaryException")}
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{padding: 0}}>
                <AncillaryExceptionContent readOnly={true} ancillaryExceptionId={ancillaryExceptionId}/>
            </DialogContent>
        </Dialog>
    );
};

export default AncillaryExceptionContainerView;